import NumberSelector from '../components/NumberSelector.vue';
import NumberRouter from '../components/NumberRouter.vue';
import Router from 'vue-router';
import Vue from 'vue';

Vue.use(Router);

export default new Router ({
    linkActiveClass: 'active',
    routes: [{
        path: '/select-numbers/:routeNumberType',
        name: 'NumberSelector',
        component: NumberSelector,
        props: true
    },
    {
        path: '/route-numbers',
        name: 'NumberRouter',
        component: NumberRouter
    }]
});